var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M320-200v-560l440 280-440 280Z"}));
}

PlayInline.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
